import {
  Anchor,
  Button,
  Table,
  Image,
  Col,
  Tab,
  Row,
  Accordion,
  Toast,
  ToastContainer,
  Modal,
  CloseButton,
  Stack,
} from "react-bootstrap";
import sidebarIcon from '../../img/navbar-active.svg';
import { Trans, useTranslation } from "react-i18next";
import { ReactNode, useState, useEffect, createRef, RefObject } from "react";
import download from "../../img/download.svg";
import "../../index.css";
import {
  Page,
  TableComp,
  ImageComp,
  ButtonComp,
  Content,
  ListComp,
  TextBlock,
  AccordianComp,
  ContentContainer,
  SubNavigation,
  SubNavGroupItem,
  ServiceTestButton,
} from "src/config/types";
import { Interweave, Markup } from "interweave";
// import { PdfFactory } from "./PdfFactory";

import setUpCode from "../../img/setUpCode.png";
import step17 from "../../img/step17.jpg";
import figure1Replaced from "../../img/figure1-replaced.png";
import figure2aReplaced from "../../img/figure2a-replaced.png";
import figure2bReplaced from "../../img/figure2b-replaced.png";
import figure3 from "../../img/figure3.png";
import figure4a from "../../img/figure4a.jpg";
import figure4b from "../../img/figure4b.png";
import figure3Animated from "../../img/figure3-animated-loading-icon.gif";
import figure5 from "../../img/figure5.png";
import figure5ES from "../../img/figure5ES.png";
import figure5a from "../../img/figure5a.png";
import figure5aES from "../../img/figure5aES.png";
import figure5b from "../../img/figure19b.png";
import figure6b from "../../img/figure6b.png";
import figure6bES from "../../img/figure6bES.png";
import figure6bReplaced from "../../img/figure6b.png";
import figure6a from "../../img/figure6a.png";
import figure7a from "../../img/figure5.png";
import figure7b from "../../img/figure19b.png";
import figure8 from "../../img/figure8.png";
import figure9 from "../../img/figure9.png";
import figure10 from "../../img/figure10.png";
import figure11 from "../../img/figure11.png";
import figure12 from "../../img/figure12.png";
import figure13 from "../../img/figure13.png";
import figure14 from "../../img/figure14.png";
import figure15 from "../../img/figure15.png";
import figure15Replaced from "../../img/figure15-replaced.png";
import figure16Replaced from "../../img/figure16-replaced.png";
import figure17Replaced from "../../img/figure17-replaced.png";
import figure18 from "../../img/figure6b.png";
import figure18Replaced from "../../img/figure6b.png";
import figure19 from "../../img/figure5.png";
import figure19b from "../../img/figure19b.png";
import figure19bES from "../../img/figure19bES.png";
import figure20 from "../../img/figure20.png";
import figure22 from "../../img/figure22.png"
import figure23 from "../../img/figure23.png"
import figure24 from "../../img/figure24.png"
import figure25 from "../../img/figure25.png"
import microsoftStoreButton from "../../img/microsoftStoreButton.png"
import Line3 from "../../img/Line3.png";
import Line4 from "../../img/Line4.png";
import Line5 from "../../img/Line5.png";
import Line6 from "../../img/Line6.png";
import Line7 from "../../img/Line7.png";
import Line8 from "../../img/Line8.png";
import Line9 from "../../img/Line9.png";
import Line10 from "../../img/Line10.png";
import Line11 from "../../img/Line11.png";
import Line12 from "../../img/Line12.png";
import Line13 from "../../img/Line13.png";
import Line14 from "../../img/Line14.png";
import figure21 from "../../img/figure21.png";
import { saveAs } from "file-saver";
import modalSpinner from "../../img/modalSpinner.svg";

import { ServiceTest } from "./ServiceTest";
import { NdtInput } from "@npd-ng/network-diagnostic-tool";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

export type DownloadStatus = {
  status: "Success" | "Error";
  message: string;
};

export type imageMapType = {
  [key: string]: string;
};

export type pdfMapType = {
  [keyu: string]: string;
};

const imageMap: imageMapType = {
  SET_UP_CODE_VALIDATION: setUpCode,
  step17: step17,
  figure1Replaced: figure1Replaced,
  figure2aReplaced: figure2aReplaced,
  figure2bReplaced: figure2bReplaced,
  figure3: figure3,
  figure4a: figure4a,
  figure4b: figure4b,
  figure3Animated: figure3Animated,
  figure5: figure5,
  figure5ES: figure5ES,
  figure5a: figure5a,
  figure5aES: figure5aES,
  figure5b: figure5b,
  figure6b: figure6b,
  figure6bES: figure6bES,
  figure6bReplaced: figure6bReplaced,
  figure6a: figure6a,
  figure7a: figure7a,
  figure7b: figure7b,
  figure8: figure8,
  figure9: figure9,
  figure10: figure10,
  figure11: figure11,
  figure12: figure12,
  figure13: figure13,
  figure14: figure14,
  figure15: figure15,
  figure15Replaced: figure15Replaced,
  figure16Replaced: figure16Replaced,
  figure17Replaced: figure17Replaced,
  figure18: figure18,
  figure18Replaced: figure18Replaced,
  figure19: figure19,
  figure19b: figure19b,
  figure19bES: figure19bES,
  figure20: figure20,
  figure22:figure22,
  figure23:figure23,
  figure24:figure24,
  figure25:figure25,
  Line3: Line3,
  Line4: Line4,
  Line5: Line5,
  Line6: Line6,
  Line7: Line7,
  Line8: Line8,
  Line9: Line9,
  Line10: Line10,
  Line11: Line11,
  Line12: Line12,
  Line13: Line13,
  Line14: Line14,
  figure21: figure21,
  modalSpinner: modalSpinner,
};

interface Props {
  pageData: Page;
  inputJson: NdtInput | undefined;
  version: string;
  versionColor: string;
  versionBorderColor: string;
  releaseDate: string;
  installerName: string;
  msiInstallerName: string;
  msiArtifactName: string;
  installerInfo: {
    installerName: string;
    size: string;
    installerPath: string;
    uninstallGuid: string;
  };
  msiInstallerInfo: {
    msiInstallerName: string;
    msiSize: string;
    msiInstallerPath: string;
    msiAppVersion: string;
    uninstallGuid: string;
  };
  build: Build;
  selectedPageId?: string;
  selectedSubNavId?: string;
  selectedAccordionId?: string;
  resetPageSelected: ()=>void;
  scheduledEndDate?: string;
}

interface AccordianRefs {
  [key: string]: {
    expanded: boolean;
    title: string;
    ref: RefObject<HTMLDivElement>;
    sectionId?: string;
  };
}

interface AccordionDefault {
  defaultActiveKey?: string;
}

export interface Build {
  date: string;
  version: string;
  name: string;
}

function PageFactory(props: Props) {
  const {
    pageData,
    version,
    versionColor,
    versionBorderColor,
    releaseDate,
    installerName,
    msiInstallerName,
    msiArtifactName,
    installerInfo,
    msiInstallerInfo,
    inputJson,
    build,
    scheduledEndDate
  } = props;
  const navigate = useNavigate();
   const [searchParams] = useSearchParams()
  const { t, i18n } = useTranslation();
  const [activeTab, setActiveTab] = useState<string>("");
  const [downloadStatus, setDownlaodStatus] = useState<DownloadStatus>();
  const [showToast, setShowToast] = useState(false);
  const [ShowImage, setShowImage] = useState(false);
  const [showSrc, setShowSrc] = useState("");
  const [pdfReady, setPdfReady] = useState(true);
  const development = new URL(window.location.href).searchParams.get(
    "development"
  );

  const accordionRefs: AccordianRefs = {};

  const handleClose = () => setShowImage(false);

  const url = document.location.toString();
  const baseurl = url.includes("localhost")
    ? "https://enaep.stage25.naepnpd.org/"
    : new URL(".", document.location.toString()).href;

  var env = url.includes("ed.gov")
    ? "prod"
    : url.split(".").length < 2 || url.split(".")[1].substring(0, 4) === "html"
    ? "stage25"
    : url.split(".")[1];
  var origin = window.location.origin;

  useEffect(() => {
    const forceSubSection = (data: SubNavigation) => {
      
        data.groups.forEach((group) => {
          if (group.items.find((item) => item.sectionId === props.selectedSubNavId)) {
            if(props.selectedSubNavId){
              setActiveTab(props.selectedSubNavId);
              (props.selectedPageId) ? pageNavigation(props.resetPageSelected) : subSectionNavigation(props.selectedSubNavId);
            }
            if (props.selectedAccordionId) {
              accordianNavigation(props.selectedAccordionId);
            }
          }
        });
    };
    if (pageData.subSections) {
      if (props.selectedSubNavId) {
        forceSubSection(pageData.subSections);
      } else if (activeTab === "") {
        setDefaultActiveTab(pageData.subSections);
      }
    }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.selectedSubNavId,props.selectedAccordionId,activeTab]);
  useEffect(() => {
   if(props.selectedPageId){
     pageNavigation();
   }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.selectedPageId]);

  const resolveInstallerUrl = (installerName: string) => {
    const host = window.location.origin.includes("localhost")
      ? "https://enaep.dev26.npdng.org"
      : window.location.origin;
    //const env = host.split(".")[1];
    return `${host}/download-center/ng-enaep-secure-browser/${installerName}`;
  };

  const resolveMsiInstallerUrl = (installerName: string) => {
    const host = window.location.origin.includes("localhost")
      ? "https://enaep.dev26.npdng.org"
      : window.location.origin;
    //const env = host.split(".")[1];
    return `${host}/download-center/ng-enaep-secure-browser/msi/${installerName}`;
  };

  const accordianNavigation = (eventKey: string) => {
    let timeout = 0;
    const accordion = accordionRefs[eventKey].ref?.current;
    Object.keys(accordionRefs).forEach((key) => {
      console.log("acc key: ", key);
      console.log("ref: ", accordionRefs[key]);
      if (accordionRefs[key].expanded && key !== eventKey) {
        (
          accordionRefs[key].ref?.current?.querySelector(
            ".accordion-button"
          ) as HTMLElement
        )?.click();
        console.log("acc clicked: ", key);
      }
      if (timeout === 0) {
        timeout += 200;
      } else {
        timeout += 35;
      }
    });
    if (!accordionRefs[eventKey].expanded) {
      if (timeout === 0) {
        timeout += 200;
      } else {
        timeout += 35;
      }
      (
        accordion?.querySelector(".accordion-button.collapsed") as HTMLElement
      )?.click();
      accordionRefs[eventKey].expanded = true;
    }
    setTimeout(() => {
      const scrollTarget = accordion?.getBoundingClientRect();
      console.log(scrollTarget, "scrollTarget");
      window.scrollTo({
        top: window.scrollY - 145 + (scrollTarget?.top || 0),
        behavior: "instant",
      });
    }, timeout);
  };
  const subSectionNavigation = (eventKey: string) => {
    let timeout = 0;
    const section = window.document.getElementById(`pane-${eventKey}`);
    setTimeout(() => {
      const scrollTarget = section?.getBoundingClientRect();
      console.log(scrollTarget, "scrollTarget");
      if(props.selectedSubNavId !== "at-scale-installation-instructions"){
        window.scrollTo({
          top: window.scrollY - 145 + (scrollTarget?.top || 0),
          behavior: "instant",
        });
      }
      else{
        if(!props.selectedAccordionId){
          window.scrollTo({
            top:window.scrollY - 145 + (scrollTarget?.top || 0),
            behavior: "instant",
          });
        }
      }
    }, timeout);
  };
  const pageNavigation = (cb?:()=>void) => {
    let timeout = 0;
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: "instant",
      });
       if(cb)cb();
    }, timeout);
  };

  const setDefaultActiveTab = (data: SubNavigation) => {
    if (activeTab=== "") {
      data.groups.forEach((group) => {
        group.items.forEach((item) => {
          if(item.default){
            setActiveTab(item.sectionId);
          }
        });
      });
    }
  };

  const handleShow = (e: any) => {
    console.log(imageMap[e.target?.id]);
    const imgSrc = imageMap[e.target?.id];
    setShowSrc(imgSrc);
    setShowImage(true);
  };

  const getSectionTitle = (id: string): string => {
    let title = "";
    if (pageData.subSections) {
      pageData.subSections.groups.forEach((group) => {
        const section = group.items.find((item) => item.sectionId === id);
        if (section) title = section.section.title;
      });
    }
    return title;
  };

  const textParser = (val: string) => {
    const strs = val
      .replace("{{env}}", env)
      .replace("{{origin}}", origin)
      .replace("{{msiInstallerName}}", msiInstallerName)
      .replace(/{{msiArtifactName}}/g, msiArtifactName)
      .replace(/{uninstallGuid}/g,msiInstallerInfo.uninstallGuid)
      .replace(/{{scheduledEndDate}}/g, scheduledEndDate)
      .split("##");
    const results = strs.map((str, index) => {
      if (index % 2 === 1) {
        //parts[0]: navigation or fuction or link
        //navi:
        //  parts[1]: the Page we're navigating to
        //  parts[2]: the sub section we're navigating to, leave blank for pages w/o sub sections
        //  parts[3]: Text to display in the link
        //  parts[4]: The accordian key
        // func: TODO as part of speedTest and diagnostic tool
        //link:
        //  parts[1]: if the value of this is HERE, replace it with the url & text with that of the download center in the current env. Otherwise parts[1] is the href of the anchor tag.
        //  parts[2]: the text in display in the anchor tag.
        let parts = str.split(";;");

        // if(parts[1] === pageId) {
        //   // Need separate return for only section change on same page
        // }
        if (parts[0] === "link") {
          if (parts[1] === "HERE" || parts[1] === "AQUÍ") {
            return <a href={baseurl + "index.html"}>{baseurl}index.html</a>;
          } else {
            return <a href={parts[1]}>{parts[2]}</a>;
          }
        }
        if (parts[0] === "navi") {
          if (parts[1] === pageData.pageId) {
            if (parts[2] === activeTab && parts.length > 4) {
              // part[3] in this scenario will be the accordion ID
              return (
                <Link onClick={()=>accordianNavigation(parts[3])} to={`/${i18n.language}/${parts[1]}/${parts[2]}/${parts[3]}?${searchParams}`}>
                  {parts[parts.length - 1]}
                </Link>
              );
            }
          }
          const subNav = parts.length > 4 ? [parts[2], parts[3]] : [parts[2]];
          return (
            <Link
              to={(`/${i18n.language}/${parts[1]}/${subNav}?${searchParams}`)}
              style={{
                display: "inline",
              }}
            >
              {parts[parts.length - 1]}
            </Link>
          );
        }
        if (parts[0] === "version") {
          return { version };
        }
        return str;
      } else {
        return str;
      }
    });
    return results;
  };

  const renderPage = (data: Page) => {
    return (
      <>
        <div className="installationResourceContainer">
          <h3>{t(data.title)}</h3>
          <p>
            <Trans>
              {typeof data.description === "string" &&
              data.description?.includes("##")
                ? textParser(data.description)
                : t(data.description, { env: env, origin: origin })}
            </Trans>
          </p>
        </div>
        {data?.subSections && renderSubSections(data.subSections)}
        {data?.content && data.content.map((item) => renderContent(item))}
      </>
    );
  };

  const renderContent = (data: Content, sectionID?: string) => {
    switch (data?.type) {
      case "List":
        return renderList(data as ListComp);

      case "TextBlock":
        return renderTextBlock(data as TextBlock);

      case "ContentContainer":
        return renderContentContainer(data as ContentContainer);

      case "Table":
        return renderTable(data as TableComp);

      case "Accordian":
        return renderAccordian(data as AccordianComp, sectionID);

      case "Button":
        return renderButton(data as ButtonComp);

      case "Image":
        let imageData = data as ImageComp;
        return (
          <Image
            id={imageData.source}
            src={imageMap[imageData.source]}
            thumbnail
            alt={imageData?.alt}
            onClick={handleShow}
            style={imageData.styling}
          />
        );

      default:
        let text: string = data?.text || "";
        if (text === "https://api.enaep.prod25.naepnpd.org") {
          console.log("text includes ##: ", text?.includes("##"));
        }
        if (data.ignoreParse) {
          return <p style={data.styles}>{text}</p>;
        }

        return (
          <p style={data.styles}>
            <>
              {typeof text !== "string" ? (
                ""
              ) : text?.includes("##") ? (
                <Trans>{textParser(text)}</Trans>
              ) : (
                <Markup
                  content={text
                    ?.replace("{{env}}", env)
                    .replace("{{origin}}", origin)
                    .replace("{{msiInstallerName}}", msiInstallerName)
                    .replace(/{{msiArtifactName}}/g, msiArtifactName)
                    .replace(/{uninstallGuid}/g,msiInstallerInfo.uninstallGuid)
                    .replace(/{{scheduledEndDate}}/g, scheduledEndDate)}
                    
                    
                />
              )}
            </>
          </p>
        );
    }
  };

  const renderAccordian = (data: AccordianComp, sectionId?: string) => {
    accordionRefs[data.key].ref = createRef<HTMLDivElement>();
    if (sectionId) accordionRefs[data.key].sectionId = sectionId;
    const activeKey: AccordionDefault = {};
    if (development) {
      activeKey["defaultActiveKey"] = data.key;
    }
    return (
      <Accordion
        {...activeKey}
        onSelect={(e) => {
          accordionRefs[data.key].expanded = !accordionRefs[data.key].expanded;
          console.log("acc select logged", accordionRefs[data.key].expanded);
          (accordionRefs[data.key].expanded) ? console.log("The accordion was selected while it was expanded.") : navigate(`/${i18n.language}/${pageData.pageId}/${sectionId}?${searchParams}`);
        }}
        ref={accordionRefs[data.key].ref}
        id={data.key}
      >
        <Accordion.Item eventKey={data.key}>
          <Accordion.Header>
            <h5>{data.title}</h5>
          </Accordion.Header>
          <Accordion.Body>
            {data.contents.map((item) => renderContent(item))}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  };

  const renderList = (data: ListComp) => {
    return (
      <>
        {data?.title && (
          <p style={{ ...data.titleStyles, marginTop: "10px" }}>
            <Interweave content={data.title} />
          </p>
        )}
        {data?.style ? (
          <ol type={data.style === "letters" ? "a" : "1"}>
            {data.items.map((item) => {
              return (
                <li style={{ paddingBottom: "12px" }}>{renderContent(item)}</li>
              );
            })}
          </ol>
        ) : (
          <ul>
            {data.items.map((item) => {
              return <li>{renderContent(item)}</li>;
            })}
          </ul>
        )}
      </>
    );
  };

  const renderSubNavAccordions = (section: SubNavGroupItem) => {
    const sectionId = section.sectionId;
    section.section.content.forEach((content) => {
      if (content?.type === "Accordian") {
        const accordion = content as AccordianComp;
        accordionRefs[accordion.key] = {
          ref: createRef<HTMLDivElement>(),
          title: accordion.title,
          expanded: false,
          sectionId: sectionId,
        };
      }
    });
    return (
      <>
        {Object.keys(accordionRefs).map((key) => {
          if (accordionRefs[key].sectionId === sectionId) {
            return (
              <p>
                <Link
                to={(`/${i18n.language}/${pageData.pageId}/${sectionId}/${key}?${searchParams}`)}
                style={{
                  display: "inline",
                  textDecoration: props.selectedAccordionId?.includes(key) ? "underline" : 'none',
                  fontWeight: props.selectedAccordionId?.includes(key) ? 700 : 400,
                }}
                >
                  <p className="accordion-nav-link">
                    {accordionRefs[key].title}
                  </p>
                </Link>
              </p>
            );
          } else {
            return <></>;
          }
        })}
      </>
    );
  };

  const renderSubSections = (data: SubNavigation) => {
    return (
      <>
        <hr />
        <Tab.Container
          id="left-tabs-example"
          activeKey={activeTab}
          defaultActiveKey={activeTab}
          mountOnEnter={true}
        >
          <Row>
            <Col sm={3} className="sticky-panel">
              {data.groups.map((group, gIndex) => {
                return (
                  <div className="nav-sidebar-wrapper">
                    <h6 className="nav-sidebar-sub-header">{t(group.title)}</h6>
                    <div className="nav-sidebar-group">
                      {group.items.map((item, iIndex) => {
                        return (
                          <>
                              <Link to={`/${i18n.language}/${pageData.pageId}/${item.sectionId}?${searchParams}`}
                              style={{
                                  display: "inline",
                                  textDecoration: props.selectedSubNavId?.includes(item.sectionId) ? "underline" : 'none',
                                  fontWeight: props.selectedSubNavId?.includes(item.sectionId) ? 700 : 400,
                              }}>
                                <Stack direction="horizontal" gap={0} className="nav-sidebar-stack">
                                  {props.selectedSubNavId?.includes(item.sectionId) ? <Image src = {sidebarIcon} style={{width: "15px", height: "10px", paddingLeft:"4px"}}/> : <div style={{width:"16px"}}></div>}
                                  <div className="nav-sidebar-link">
                                    {t(item.title)}
                                  </div>
                                </Stack>
                              </Link>
                            <div>{renderSubNavAccordions(item)}</div>
                          </>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </Col>
            <Col sm={9}>
              <Tab.Content>
                {data.groups.map((group, gIndex) => {
                  return (
                    <>
                      {group.items.map((item, iIndex) => {
                        return (
                          <Tab.Pane eventKey={item.sectionId} key={iIndex}>
                            <div className="mb-5" id={`pane-${item.sectionId}`}>
                              <div className="tablist-content-wrapper">
                                <div className="tablist-content-panel-list">
                                  <div className="tablist-content-subheader">
                                    <h5 className="mb-0">
                                      {t(item.section.title)}
                                    </h5>
                                    {item.section.pdfId && (
                                      <Button
                                        className="tablist-specific-download"
                                        disabled={!pdfReady}
                                        style={{
                                          backgroundColor: "#1159a7",
                                          color: "white",
                                          cursor: "pointer!imortant",
                                        }}
                                        onClick={async () => {
                                          const { RenderPDF } = await import(
                                            "../RenderPdf"
                                          );
                                          setPdfReady(() => false);
                                          console.log("pdf ready: ", pdfReady);
                                          const blob = await RenderPDF({
                                            pageData: pageData,
                                            sectionId: activeTab,
                                            version: version,
                                            headerTitle: t("headerTitle"),
                                            versionText: t("version"),
                                            releaseDateText: t("releaseDate"),
                                            installerName: installerName,
                                            msiInstallerName: msiInstallerName,
                                            msiArtifactName: msiArtifactName,
                                            build: build,
                                            msiInstallerInfo: msiInstallerInfo,
                                          });
                                          saveAs(
                                            blob,
                                            `${getSectionTitle(activeTab)}.pdf`
                                          );
                                          setPdfReady(() => true);
                                        }}
                                      >
                                        {pdfReady ? (
                                          <Image
                                            src={download}
                                            style={{
                                              width: "18px",
                                              height: "18px",
                                              marginRight: "10px",
                                            }}
                                          />
                                        ) : (
                                          <div className="spinning-animation">
                                            <Image
                                              src={modalSpinner}
                                              style={{
                                                width: "18px",
                                                height: "18px",
                                              }}
                                            />
                                          </div>
                                        )}
                                        {t("pdfDownalodButtonText")}
                                      </Button>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="os-hardware-content-wrapper tablist-content-wrapper">
                                {item.section.content.map((data) =>
                                  renderContent(data, item.sectionId)
                                )}
                              </div>
                            </div>
                          </Tab.Pane>
                        );
                      })}
                    </>
                  );
                })}
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </>
    );
  };

  const renderTextBlock = (data: TextBlock): ReactNode => {
    switch (data.blockType) {
      case "version": {
        return (
          <span
            style={{
              backgroundColor: versionColor,
              border: "1px solid #000",
              display: "inline-block",
              borderColor: versionBorderColor,
              borderWidth: "1px",
              borderStyle: "solid",
              borderRadius: "5px",
              boxShadow: "none",
              maxWidth: "fit-content",
              padding: "0.4rem 0.6rem",
              fontWeight: "500",
              marginBottom: "1rem",
            }}
          >
            {version}
          </span>
        );
      }

      case "releaseDate": {
        return (
          <>
            <p>{releaseDate}</p>
          </>
        );
      }

      case "msiAppVersion": {
        return (
          <>
            <Interweave content={data.text} /> {msiInstallerInfo.msiAppVersion}
          </>
        );
      }

      case "header": {
        return (
          <h4 style={{ fontSize: "18px", fontWeight: "700" }}>
            <Interweave content={data.text} />
          </h4>
        );
      }

      case "custom": {
        return <div style={data.styles}>{data.text}</div>;
      }
    }
  };

  const renderTable = (data: TableComp): ReactNode => {
    return (
      <div className="table-wrapper">
        <Table responsive="xl" bgcolor="#fafafa" className="mb-0 ">
          <thead>
            <tr className={`${data.columns && "same-col-widths"}`}>
              {data.header.cells.map((cell, index) => {
                let style: React.CSSProperties = cell?.width
                  ? { width: `${cell.width}%` }
                  : {};
                return (
                  <th style={style} key={`th-${index}`}>
                    {cell.content.map((item) => renderContent(item))}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {data.rows.map((row) => {
              let style: React.CSSProperties = {};
              return (
                <tr className="border">
                  {row.cells.map((cell) => {
                    return (
                      <td style={style} colSpan={row.colSpan}>
                        {cell.content.map((item) => renderContent(item))}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  };

  const renderButton = (data: ButtonComp): ReactNode => {
    switch (data.btnType) {
      case "Download": {
        return (
          <Button
            variant="outline-secondary"
            style={{
              backgroundColor: "#1159a7",
              color: "white",
              cursor: "pointer !important",
              marginRight: "15px",
            }}
            onClick={() => {
              try {
                const url = `${resolveInstallerUrl(installerName)}`;
                var a = document.createElement("a");
                a.href = url;
                a.rel = "noopener";
                a.download = "naep-assessment-app-installer.exe";
                document.body.appendChild(a);
                a.click();
                a.remove();
              } catch (e) {
                setShowToast(true);
                setDownlaodStatus({
                  status: "Error",
                  message: "An error has occurred. Please try again.",
                });
              }
            }}
          >
            <Image
              src={download}
              style={{
                width: "24px",
                height: "24px",
                marginRight: "10px",
              }}
            />
            {t(data.text ?? "Download")}
          </Button>
        );
      }
      case "DownloadMsi": {
        return (
          <Button
            variant="outline-secondary"
            style={{
              backgroundColor: "#1159a7",
              color: "white",
              cursor: "pointer !important",
              marginRight: "15px",
            }}
            onClick={() => {
              try {
                const url = `${resolveMsiInstallerUrl(msiInstallerName)}`;
                var a = document.createElement("a");
                a.href = url;
                a.rel = "noopener";
                a.download = msiInstallerName;
                document.body.appendChild(a);
                a.click();
                a.remove();
              } catch (e) {
                setShowToast(true);
                setDownlaodStatus({
                  status: "Error",
                  message: "An error has occurred. Please try again.",
                });
              }
            }}
          >
            <Image
              src={download}
              style={{
                width: "24px",
                height: "24px",
                marginRight: "10px",
              }}
            />
            {t(data.text ?? "Download")}
          </Button>
        );
      }
      case "DownloadMicrosoftStore": {
        return (
          <Image
          src={microsoftStoreButton}
            style={{
              backgroundColor: "#1159a7",
              color: "white",
              cursor: "pointer",
              marginRight: "15px",
            }}
            onClick={() => {
              try {
                const url = `https://apps.microsoft.com/store/detail/XP8C7V09CB74NL`;
                var a = document.createElement("a");
                a.href = url;
                a.rel = "noopener";
                a.download = "NAEP Assessment";
                document.body.appendChild(a);
                a.click();
                a.remove();
              } catch (e) {
                setShowToast(true);
                setDownlaodStatus({
                  status: "Error",
                  message: "An error has occurred. Please try again.",
                });
              }
            }}
          />
        );
      }
      case "ServiceTest": {
        return (
          <ServiceTest
            data={data as ServiceTestButton}
            inputJson={inputJson as NdtInput}
          />
        );
      }

      case "Link": {
        return (
          <Anchor
            style={{
              color: "#2478cc",
              verticalAlign: "middle",
              display: "inline-block",
              cursor: "pointer",
            }}
            onClick={() => {
              try {
                const url = `${resolveInstallerUrl(installerName)}`;
                var a = document.createElement("a");
                a.href = url;
                a.rel = "noopener";
                a.download = "naep-assessment-app-installer.exe";
                document.body.appendChild(a);
                a.click();
                a.remove();
              } catch (e) {
                setShowToast(true);
                setDownlaodStatus({
                  status: "Error",
                  message: "An error has occurred. Please try again.",
                });
              }
            }}
          >
            {data.text}
            {data?.text && data.text.includes(".exe") && (
              <>
                <br />
                {installerInfo.size}
              </>
            )}
          </Anchor>
        );
      }
      case "Error": {
        return (
          <Link
            style={{
              width: "14rem",
              height: "3rem",
              padding: ".5rem",
              paddingTop: ".75rem",
              borderRadius: "5px",
              backgroundColor: "#1159a7",
              boxSizing: "border-box",
              fontFamily: "OpenSans-Regular, Open Sans, sans-serif",
              color: "#ffffff",
              textAlign: "center",
              textDecoration: "none",
              alignItems: "center !important",
              marginBottom:"2rem"
            }}
            to="/getting-started"
          >
            {data.text}
          </Link>
        );
      }

      case "LinkMsi": {
        return (
          <Anchor
            style={{
              color: "#2478cc",
              verticalAlign: "middle",
              display: "inline-block",
              cursor: "pointer",
            }}
            onClick={() => {
              try {
                const url = `${resolveMsiInstallerUrl(msiInstallerName)}`;
                var a = document.createElement("a");
                a.href = url;
                a.rel = "noopener";
                a.download = msiInstallerName;
                document.body.appendChild(a);
                a.click();
                a.remove();
              } catch (e) {
                setShowToast(true);
                setDownlaodStatus({
                  status: "Error",
                  message: "An error has occurred. Please try again.",
                });
              }
            }}
          >
            {msiInstallerName}
            {msiInstallerName.includes(".msi") && (
              <>
                <br />
                {msiInstallerInfo.msiSize}
              </>
            )}
          </Anchor>
        );
      }
      case "LinkMicrosoftStore": {
        return (
          <Anchor
            style={{
              color: "#2478cc",
              display: "flex",
              cursor: "pointer",
              alignItems: "center"
            }}
            onClick={() => {
              try {
                const url = `https://apps.microsoft.com/store/detail/XP8C7V09CB74NL`;
                var a = document.createElement("a");
                a.href = url;
                a.rel = "noopener";
                a.download = data.text ?? "NAEP Assessment";
                document.body.appendChild(a);
                a.click();
                a.remove();
              } catch (e) {
                setShowToast(true);
                setDownlaodStatus({
                  status: "Error",
                  message: "An error has occurred. Please try again.",
                });
              }
            }}
          >
           {data.text ?? "Microsoft Store NAEP Assessment App"}
          </Anchor>
        );
      }
    }
  };

  const renderContentContainer = (data: ContentContainer) => {
    return (
      <div style={data.style}>
        {data.content.map((item) => renderContent(item))}
      </div>
    );
  };

  return (
    <div className={(pageData.pageId.includes("404") || pageData.pageId.includes("maintenance"))? "tab-content-overflow" :"tab-content-overflow tab-content-background-spacing"}>
      <Modal
        show={ShowImage}
        animation={true}
        centered
        className="image-modal-wrapper"
      >
        <Modal.Body className="image-modal-body">
          <span className="modal-close-button" />
          <CloseButton className="image-modal-close" onClick={handleClose} />
          <Image src={showSrc} />
        </Modal.Body>
      </Modal>
      {renderPage(pageData)}
      {pageData?.includeToast && (
        <ToastContainer
          position="top-center"
          className="p-3"
          style={{ zIndex: 1 }}
        >
          <Toast
            onClose={() => setShowToast(false)}
            show={showToast}
            bg={downloadStatus?.status === "Success" ? "success" : "danger"}
            style={{
              color: "white",
              width: "auto",
              fontSize: "18px",
            }}
          >
            <Toast.Header>
              <img
                src="holder.js/20x20?text=%20"
                className="rounded me-2"
                alt=""
              />
              <strong className="me-auto">{downloadStatus?.status}</strong>
            </Toast.Header>
            <Toast.Body>{downloadStatus?.message}</Toast.Body>
          </Toast>
        </ToastContainer>
      )}
    </div>
  );
}

export default PageFactory;
